import type { Event } from "@mux/sdk/v2/client"
import { createGlobalSyncEventHandler, type GlobalSyncEventHandlerInput } from "./event-handler"

export function createGlobalEventController(input: GlobalSyncEventHandlerInput & {
  listen: (handler: (event: { name: string; details: Event }) => void) => () => void
  start: () => Promise<unknown> | unknown
  connected: () => boolean
}) {
  const recovery = new AbortController()
  const unsubscribe = input.listen(createGlobalSyncEventHandler({
    ...input,
    recoverySignal: recovery.signal,
  }))
  let frame: number | undefined
  let timer: ReturnType<typeof setTimeout> | undefined

  function start() {
    const run = () => {
      timer = setTimeout(() => {
        timer = undefined
        if (input.connected()) void input.start()
      }, 0)
    }
    if (typeof requestAnimationFrame !== "function") {
      run()
      return
    }
    frame = requestAnimationFrame(() => {
      frame = undefined
      run()
    })
  }

  return {
    start,
    dispose() {
      recovery.abort()
      unsubscribe()
      if (frame !== undefined) cancelAnimationFrame(frame)
      if (timer !== undefined) clearTimeout(timer)
    },
  }
}
